// Dev note: this function is duplicated in authUtils.  With this function just in
// authUtils, it causes webpack to create extra dev time bundles to cater for the
// fact that it is shared between two entry point (webAuthInitializer and tal).
// Duplication here severs tal main's usage of authUtils and the bundling
// is consistent between dev and prod.
export function getLocationOrigin() {
  const { origin, protocol, hostname, port } = window.location;
  const optionalPort = port ? `:${port}` : "";
  return origin || `${protocol}//${hostname}${optionalPort}`;
}

export function logout() {
  window.location.assign(`${getLocationOrigin()}/logout`);
}
